import React from 'react';
import {YMInitializer} from "react-yandex-metrika";

const YandexMetrics: React.FC = () => {
    return (
        <div>
            <YMInitializer accounts={[61862269]}/>
        </div>
    );
};

export default YandexMetrics;
